<template>
  <div>
    <h4 class="title">Facturas</h4>
    <div class="row row-responsive">
      <div class="column column-xs-100 column-sm-50">
        <label for="">Seleccione el año:</label>
        <span class="select">
          <select v-model="selectedYear">
            <option v-for="(year, index) in years"
             :key="index">{{year}}</option>
          </select>
          <span class="arrow"></span>
        </span>
      </div>
      <div class="column column-xs-100 column-sm-50">
        <label for="">Seleccione el mes:</label>
        <span class="select">
          <select id="month" v-model="selectedMonth">
            <option value="" disabled selected>---</option>
            <option v-for="month in MONTHS.data"
              :value="month.id"
              :key="month.id"
            >
              {{month.month}}
            </option>
          </select>
          <span class="arrow"></span>
        </span>
        <div v-if="isError" class="error">
          Seleccione un mes
        </div>
      </div>
      <div class="row">
        <div class="column">
          <button class="button float-right"
            :disabled="buttonDisabled"
            @click.prevent="submitMonth()">
            Siguiente
          </button>
        </div>
      </div>
      <div class="row" v-if="showMFA">
        <div class="column column-50 column-offset-25" style="text-aling:center">
          <MFAHandler button="hideButton" v-on:tokenObtained="onClickedChild">
          </MFAHandler>
        </div>
      </div>
      <modal
        name="invoice-message"
        id="invoice-message"
        width="80%"
        :maxWidth="620"
        :adaptive="true"
        height="auto"
      >
        <div class="box-success">
          <h3 class="title"><b>Facturas</b></h3>
          <a
            href="#"
            class="close"
            @click.prevent="$modal.hide('invoice-message')"
          >
            <img
              alt="Ingresa"
              src="https://icongr.am/material/close.svg?size=20&color=currentColor">
          </a>
          <div>
            <p>
              En unos minutos enviaremos un correo a la cuenta
              <b class="-green">{{$store.getters.getEmail}}</b>
              con un enlace para descargar la facturación.
              Por favor revisa tu buzón de entrada (y spam) y haz clic en el enlace,
              o puedes copiarlo y pegarlo en el navegador.
            </p>
          </div>
        </div>
        <div class="modal-buttons">
          <button
            class="btn btn--green mb-3"
            @click="$modal.hide('invoice-message')"
          >
            Cerrar
          </button>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>

import MONTHS from '@/constants/months'
import MFAHandler from '@/components/MFAHandler'
import httpRequestMixin from '@/mixins/httpRequestMixin'
import mixins from '@/mixins/index'

export default {
  name: 'UserProfileInvoices',
  components: {
    MFAHandler
  },
  mixins: [mixins, httpRequestMixin],
  data () {
    return {
      MONTHS,
      selectedMonth: '',
      selectedYear: new Date().getFullYear(),
      years: [],
      isError: false,
      hideButton: true,
      showMFA: false,
      buttonDisabled: false
    }
  },
  watch: {
    selectedYear: function () {
      this.buttonDisabled = false
      this.showMFA = false
    },
    selectedMonth: function () {
      this.buttonDisabled = false
      this.showMFA = false
      this.isError = false
    }
  },
  created () {
    this.getYears()
  },
  methods: {
    onClickedChild: async function (token) {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/investor/invoices/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          year: this.selectedYear,
          month: this.selectedMonth,
          token
        }
      }
      const response = await this.httpRequest(options)
      if (response.status === 201) {
        this.showMFA = false
        this.buttonDisabled = false
        this.$modal.show('invoice-message')
      } else {
        this.showMFA = false
        this.buttonDisabled = false
        const message = this.convertArraytoString(response.data)
        this.modalError(message, 'warning')
      }
    },
    submitMonth: function () {
      this.isError = this.selectedMonth === ''
      if (!this.isError) {
        this.isError = false
        this.showMFA = true
        this.buttonDisabled = true
      }
    },

    getYears: function () {
      const yearMax = this.selectedYear
      const yearMin = 2020

      for (let i = yearMax; i >= yearMin; i--) {
        this.years.push(i)
      }
    }
  }
}
</script>

<style lang="scss">

#invoice-message {
  .box-success {
    padding: 2rem;
  }

  .close {
    $offset: 15px;

    position: absolute;
    top: $offset;
    right: $offset;
  }

  .modal-buttons {
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/userProfileResume/UserProfileInvoices.vue